import { defineStore } from "pinia";

import * as R from "ramda";
import axios from "../../axios-auth";
import qs from "qs";
import { getMediaUrl } from "../../helpers/helpers";
import { useUrlsStore } from "@/stores/modules/urls";

export const useCustomerStore = defineStore("customer", {
  state: () => ({
    customer: null,
    isLogin: 1,
    customerImages: []
  }),

  getters: {
    getCustomer(state) {
      return state.customer;
    },
    getIsLogin(state) {
      return state.isLogin;
    },
    getCustomerImages(state) {
      return R.pathOr([], ["customerImages"], state);
    },
    getCustomerImageGalleryItems(state) {
      const items = this.getCustomerImages;
      const urlsStore = useUrlsStore();
      const baseUrl = urlsStore.getUrl("mediaBaseUrl");

      return R.mapObjIndexed(item => {
        return {
          id: item.uuid,
          url: getMediaUrl(R.pathOr("", ["thumbnails", "thumb"], item), baseUrl)
        };
      }, items);
    }
  },

  actions: {
    setCustomer(payload) {
      this.customer = payload;
    },
    setIsLogin(payload) {
      if (payload) this.isLogin = 1;
      else this.isLogin = 0;
    },
    addCustomerImage(uuid) {
      this.customerImages = [...this.customerImages, uuid];
    },
    emptyCustomerGallery(all) {
      if (all) this.customerImages = [];
      else {
        this.customerImages = R.filter(item => {
          const uploaded = R.pathOr(false, ["uploaded"], item);
          return uploaded;
        }, this.customerImages);
      }
    },
    deleteCustomerImage(uuid) {
      const urlsStore = useUrlsStore();
      this.customerImages = R.filter(item => {
        return item.uuid !== uuid;
      }, this.customerImages);

      axios.instance
        .post(urlsStore.getUrl("apiDeleteImageUrl") + payload, {
          customer: this.getCustomer
        })
        .then(result => {
          var response = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    loadCustomerGallery(payload) {
      const urlsStore = useUrlsStore();
      axios.instance
        .post(urlsStore.getUrl("apiCustomerGalleryUrl"), {
          customer: this.getCustomer
        })
        .then(response => {
          const { success, data } = response.data;
          if (success) {
            R.forEach(item => {
              item.uploaded = false;
              this.addCustomerImage(item);
            }, data);
          }
        })
        .catch(error => {
          console.log("Error " + error);
        });
    }
  }
});
